module.exports = __webpack_public_path__ + "img/background_medio_web-760.d43f5944.webp";